/**
 * j file quota
 * Show upload quota usage for the current access key
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../services/config.service.js';
import { FileService } from '../../services/file.service.js';
import { formatUploadSize } from '../../utils/file-upload-rules.js';

export function createFileQuotaCommand(): Command {
    return new Command('quota')
        .description('Show file upload quota usage')
        .option('-j, --json', 'JSON output')
        .action(async (opts) => {
            try {
                const configService = new ConfigService();
                const config = await configService.load();
                if (!config) {
                    console.error(chalk.red('Chưa đăng nhập. Chạy "j auth" trước.'));
                    process.exit(1);
                }

                const service = new FileService();
                const quota = await service.getQuota(config);

                if (opts.json) {
                    console.log(JSON.stringify(quota, null, 2));
                    return;
                }

                const percent = quota.limitBytes > 0
                    ? Math.round((quota.usedBytes / quota.limitBytes) * 100)
                    : 0;

                console.log();
                console.log(chalk.bold('File upload quota'));
                console.log(chalk.cyan('  Used:') + ` ${formatUploadSize(quota.usedBytes)} / ${formatUploadSize(quota.limitBytes)} (${percent}%)`);
                console.log(chalk.cyan('  Remaining:') + ` ${formatUploadSize(quota.remainingBytes)}`);
                if (quota.remainingBytes <= 0) {
                    console.log(chalk.dim('  Xoá file cũ bằng "j file list" và "j file delete <id>" để giải phóng dung lượng.'));
                }
                console.log();
            } catch (error) {
                console.error(chalk.red(`Lỗi: ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
